export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    num: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    link: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    markOpened: {
      type: Boolean,
      default: true,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      opened: false,
    };
  },
  computed: {
    hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    classModifiers() {
      return {
        'document-to-review': true,
        'document-to-review--opened': this.markOpened && this.opened,
      };
    },
    symbolClassModifiers() {
      return {
        'document-to-review__symbol': true,
        'document-to-review__symbol--pdf': this.link && this.link.endsWith('pdf'),
      };
    },
  },
  methods: {
    onOpen() {
      this.opened = true;
      this.$emit('change', true);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/onboarding/document-to-review/document-to-review.js